import { styled } from "styled-components";

export const PopupWrapper = styled.div``;

export const PopupWrapBg = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
  display: block;
  &.none {
    display: none;
  }
`;

export const PopupWrap = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: whitesmoke;
  width: 700px;
  /* width: 500px; */

  overflow: hidden;

  border-radius: 60px 0 60px 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: "Noto Sans KR", sans-serif;
  @media all and (max-width: 640px) {
    width: 80%;
    border-radius: 0;
  }
`;
export const PopupImageWrapper = styled.div`
  display: flex;
`;

export const PopupInputWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-items: center;
`;

export const PopupInput = styled.input`
  /* position: absolute;
  left: 40px;
  bottom: 30px; */
`;

export const PopupLabel = styled.label`
  font-size: 14px;
  font-weight: 700;
  color: #242424;
`;

export const PopupImageWrap = styled.div`
  display: flex;
  width: 100%;
  img {
    width: 100%;
  }
  @media all and (max-width: 640px) {
    img {
      max-height: 70vh;
    }
  }
`;

export const PopupButtonWrap = styled.div`
  display: flex;
  width: 100%;
  > * {
    width: 50%;
    padding: 12px 0;
  }
  @media all and (max-width: 640px) {
    flex-direction: column;
    > * {
      width: 100%;
    }
  }
`;

export const PopupCloseButton = styled.button`
  font-size: 15px;
  font-weight: 700;

  border: 0 none;
  outline: none;
  color: #242424;
`;
